<template>
  <div class="app-container">
    <header class="app-header">
      <div class="container header-content">
        <div class="logo-title-container">
          <h1 class="centered-title">            
            <img src="@/assets/logo-dark.png" alt="Logo-dark.png" class="app-logo" width="70" height="70">
            <span class="title-text"><span class="app-title-highlight">GenAI Edu</span></span>
          </h1>         
        </div>
        <!-- <h1><span class="app-title-highlight">STEM Tutor GenAI</span> Agent (2025)</h1> -->
        
        <div class="header-actions" v-if="isLoggedIn">
          <span class="user-email">{{ userEmail }}</span>
          <button class="btn logout-btn" @click="logout">
            <span class="material-icons">logout</span>
            Logout
          </button>
        </div>
      </div>
    </header>
    <main class="container">
      <router-view/>
    </main>
    <footer class="app-footer">
      <div class="container">
        <p>&copy; 2025 GenAI Edu</p>
      </div>
    </footer>
  </div>
</template>

<script>
import apiService from '@/services/api'

export default {
  name: 'App',
  data() {
    return {
      isLoggedIn: false,
      userEmail: ''
    }
  },
  created() {
    this.checkAuthStatus()
    window.addEventListener('storage', this.checkAuthStatus)
  },
  beforeUnmount() {
    window.removeEventListener('storage', this.checkAuthStatus)
  },
  methods: {
    checkAuthStatus() {
      const sessionStr = localStorage.getItem('session')
      const session = sessionStr ? JSON.parse(sessionStr) : null
      
      if (session && session.expiresAt > Date.now()) {
        this.isLoggedIn = true
        this.userEmail = session.email
      } else {
        this.isLoggedIn = false
        this.userEmail = ''
      }
    },
    
    logout() {
      apiService.logout()
        .then(() => {
          localStorage.removeItem('session')
          this.isLoggedIn = false
          this.userEmail = ''
          this.$router.push('/login')
        })
        .catch(error => {
          console.error('Logout Error:', error)
          localStorage.removeItem('session')
          this.$router.push('/login')
        })
    }
  }
}
</script>

<style>
.app-container {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
}

.app-header {
  background-color: var(--primary-dark);
  padding: 16px 0;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
}

.header-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.app-header h1 {
  font-size: 24px;
  font-weight: 500;
  color: var(--text-on-primary);
}

.logo-title-container {
  display: flex;
  justify-content: center;
  width: 100%;
}

.centered-title {
  display: flex;
  align-items: center;
  justify-content: center;
}

.app-logo {
  margin-right: 5px;
}

.title-text {
  display: inline-block;
  vertical-align: middle;
}

.app-title-highlight {
  font-weight: 700;
  color: #8afa8a;
}

.header-actions {
  display: flex;
  align-items: center;
}

.user-email {
  color: var(--text-secondary);
  margin-right: 16px;
  font-size: 14px;
}

.logout-btn {
  display: flex;
  align-items: center;
  background-color: rgba(255, 255, 255, 0.1);
  color: var(--text-on-primary);
  border-radius: 4px;
  padding: 6px 12px;
  font-size: 14px;
  transition: background-color 0.3s;
}

.logout-btn:hover {
  background-color: rgba(255, 255, 255, 0.2);
}

.logout-btn .material-icons {
  font-size: 18px;
  margin-right: 4px;
}

main {
  flex: 1;
  padding: 24px 0;
}

.app-footer {
  background-color: var(--primary-dark);
  padding: 16px 0;
  color: var(--text-secondary);
  font-size: 14px;
}
</style>
